import { useRef } from "react";

const useAutoFocus = () => {
  const formRef = useRef(null);

  const moveFocus = (currentField) => {
    if (!formRef.current) return;

    const focusableFields = Array.from(
      formRef.current.querySelectorAll("input, select, textarea, button,phonebutton")
    ).filter((el) => !el.disabled && el.tabIndex !== -1);

    const index = focusableFields.indexOf(currentField);
    if (index !== -1 && index < focusableFields.length - 1) {
      focusableFields[index + 1].focus();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent form submission
      moveFocus(e.target);
    }
  };

  const handleSelectChange = (e) => {
    moveFocus(e.target);
  };

  return { formRef, handleKeyDown, handleSelectChange };
};

export default useAutoFocus;
